export function buildAlzuraOAuthUrl(next) {
  const state = JSON.stringify({ csrf: '5ca75bd30', next: next || null });
  const params = {
    response_type: 'code',
    client_id: import.meta.env.VUE_APP_ALZURA_CLIENT_ID,
    platform: 'autengo',
    redirect_uri: import.meta.env.VUE_APP_ALZURA_REDIRECT_URI,
    state,
  };

  const queryString = new URLSearchParams(params).toString();
  return `${import.meta.env.VUE_APP_ALZURA_OAUTH_URL}/authorize?${queryString}`;
}
